import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../../components/layout/AdminSidebar';
import AdminNavbar from '../../components/layout/AdminNavbar'; // We will use this as the header
import '../../styles/Admin.css';

const AdminLayout = () => {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <header className="admin-header">
        {/* This will be a simplified header, maybe for user menu or search */}
        <AdminNavbar />
      </header>
      <main className="admin-main-content">
        <Outlet /> {/* Child routes will render here */}
      </main>
    </div>
  );
};

export default AdminLayout;